import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { AdjustmentNote } from '../state/types'

export const useAdjustmentNoteLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadAdjustmentNote = (
            id: string,
            optimized = true
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.ADJUSTMENT_NOTES, id, !optimized) as Promise<O<AdjustmentNote>>
        }

        const loadOperationAdjustmentNotes = async (
            operationId: string,
            optimized = true
        ) => {
            const { loadMultiple } = loaders(companyId)
            const options = {
                valueFilters: [{ prop: 'operationId', value: operationId }]
            }
            const response = await loadMultiple(TableName.ADJUSTMENT_NOTES, options, optimized)
            return response.dataTypes as AdjustmentNote[]
        }

        const loadOperationsAdjustmentNotes = (
            operationIds: string[],
            dbRequest = false
        ) => {
            const { loadFilteredByList } = loaders(companyId)
            return loadFilteredByList(TableName.ADJUSTMENT_NOTES, dbRequest, 'operationId', operationIds) as Promise<AdjustmentNote[]>
        }

        return {
            loadAdjustmentNote,
            loadOperationAdjustmentNotes,
            loadOperationsAdjustmentNotes
        }
    }
}
